import { FC } from "react";

import { AssessmentSummaryReport } from "./AssessmentSummaryReport";
import { CourseEnrollmentReport } from "./SectionEnrollmentReport";
import { StudentLearningOutcomesReport } from "./StudentLearningOutcomesReport";
import { StudentCourseGradesReport } from "./StudentSectionGradesReport";
import { SystemChecksReport } from "./SystemChecksReport";

export const ReportsView: FC = () => {
  return (
    <div className="reports-view h-full space-y-8 overflow-y-auto pb-4">
      <CourseEnrollmentReport />

      <AssessmentSummaryReport />

      <StudentLearningOutcomesReport />

      <StudentCourseGradesReport />

      <SystemChecksReport />
    </div>
  );
};
